export default __webpack_public_path__ + "static/media/JobSix4.12705559.jpg";